import { useLocation } from "react-router-dom"

export const useAdministrationRedirectTarget = () => {
  const { pathname, search, hash } = useLocation()
  const subPath = pathname.replace(/^\/organization/, "")
  return `/administration${subPath}${search}${hash}`
}
